var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 32.5",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m30.8 30.7c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5-0.2 0.5-0.5 0.5zm0-0.9c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.4 0.3-0.1 0.4-0.3v-0.1c-0.1-0.1-0.2-0.3-0.4-0.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "illustrationsAccent1",
    cx: 15,
    cy: 17.4,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "m21.9 15h1.6c0.2 0 0.3-0.2 0.3-0.4 0-0.1-0.1-0.2-0.3-0.3h-1.6c-1.1 0-2.1-0.9-2.1-2.1v-1.7c0-0.2-0.1-0.3-0.3-0.3s-0.3 0.1-0.3 0.3v1.6c-0.1 1.6 1.1 2.9 2.7 2.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "m21.2 22.4h-6.6c-0.5 0.1-0.9-0.2-1-0.7s0.2-0.9 0.7-1h6.9c0.5-0.1 0.9 0.2 1 0.7s-0.2 0.9-0.7 1h-0.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m12.9 1.7c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m12.4 1.2h-0.5c-0.1 0-0.2 0.1-0.2 0.2s0.1 0.2 0.2 0.2h0.5c0.1 0 0.2-0.1 0.2-0.2s-0.1-0.2-0.2-0.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m12.9 0.3c-0.1 0-0.2 0.1-0.2 0.2v0.5c0 0.1 0.1 0.2 0.2 0.2s0.2-0.1 0.2-0.2v-0.5c0-0.1-0.1-0.2-0.2-0.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m13.9 1.2h-0.5c-0.1 0-0.2 0.1-0.2 0.2s0.1 0.2 0.2 0.2h0.5c0.1 0 0.2-0.1 0.2-0.2s0-0.2-0.2-0.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m33.3 23.9c-0.2 0-0.3 0.2-0.3 0.4v0.7c0 0.2 0.1 0.3 0.3 0.3s0.3-0.2 0.3-0.3v-0.8c0-0.2-0.1-0.3-0.3-0.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m32.4 23h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3 0.1-0.2-0.1-0.3-0.3-0.3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m33.3 21.3c-0.2 0-0.3 0.2-0.3 0.3v0.8c0 0.2 0.1 0.3 0.3 0.4 0.2 0 0.3-0.2 0.3-0.4v-0.8c0-0.1-0.1-0.3-0.3-0.3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m35 23h-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3h0.8c0.2 0 0.3-0.1 0.3-0.3s-0.1-0.3-0.3-0.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m2.1 16s0.3 2-2.1 2c0 0 2 0 2 1.9 0.2-1 1-1.8 2.1-1.9 0 0-1.6 0.4-2-2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent2",
    d: "m30.8 2.4s0.3 2-2.1 2c0 0 2 0 2 1.9 0.2-1 1.1-1.7 2.1-1.8 0-0.1-1.6 0.3-2-2.1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent2",
    d: "m5.4 27.5c0 0.6-0.4 1-0.9 1.1h-0.2c0.6 0 1 0.4 1 1v0.1c0.1-0.5 0.5-0.9 1.1-1 0-0.1-0.9 0.1-1-1.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m5.4 8.1c0 0.3-0.2 0.6-0.5 0.7h-0.2s0.7 0 0.6 0.6c0.1-0.3 0.4-0.6 0.7-0.6 0 0-0.5 0.1-0.6-0.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m23.4 1.5c-0.4 0-0.7-0.2-0.7-0.6s0.2-0.7 0.6-0.7h0.2c0.3 0 0.6 0.3 0.6 0.6 0 0.4-0.3 0.7-0.7 0.7zm0-1c-0.2 0-0.4 0.2-0.4 0.4s0.2 0.4 0.4 0.4 0.4-0.2 0.4-0.4c0.1-0.2-0.1-0.4-0.4-0.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent2",
    d: "m2.5 4.3c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5-0.2 0.5-0.5 0.5zm0-0.8c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3 0.3-0.1 0.3-0.3-0.2-0.3-0.3-0.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent2",
    d: "m35.5 14.1c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5-0.3 0.5-0.5 0.5zm0-0.9c-0.2 0-0.3 0.1-0.3 0.3s0.1 0.3 0.3 0.3 0.3-0.1 0.3-0.3c0-0.1-0.2-0.3-0.3-0.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "m22.1 24.4c-0.2-0.3-0.5-0.5-0.9-0.5h-6.6c-0.5-0.1-0.9 0.2-1 0.7s0.2 0.9 0.7 1h6.1c0.4-0.5 1-0.9 1.7-1.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsGreen",
    d: "m23.7 25.2c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5c0.1-2-1.5-3.5-3.5-3.5zm-0.3 5.5-1.7-1.8 0.5-0.6 1.1 1.1 1.8-2.8 0.6 0.5-2.3 3.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsAccent1",
    d: "m15.7 9h-3.2c-1 0-1.8 0.8-1.8 1.8v17c0 1 0.8 1.8 1.8 1.8h2.4c-1.3-0.7-2-2.1-2-3.5v-12.8c0-1.9 1.1-3.6 2.8-4.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m19.3 29.6h-6.8c-1 0-1.8-0.8-1.8-1.8v-17c0-1 0.8-1.8 1.8-1.8h10.8c1 0 1.8 0.8 1.8 1.8v13.5c0.4 0.1 0.7 0.3 1.1 0.5v-14c0-1.6-1.3-2.9-2.9-2.9h-10.8c-1.6 0-2.9 1.3-2.9 2.8v17c0 1.6 1.3 2.9 2.9 2.9h7.2c-0.2-0.3-0.3-0.6-0.4-1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d78bb48762af2217d3b864bf8a6ac393.svg";
export { ForwardRef as ReactComponent };